<template>
  <div>


    <van-nav-bar title="短信快捷登录" fixed="fixed">
      <template #left>
        <div @click="back()" class="backButton">
          <svg-icon icon-class="backButton" style="width:12px;height:20px;"></svg-icon>
        </div>
      </template>
    </van-nav-bar>


    <div style="padding-top: 46px;">
      <div style="padding-left: 24px;padding-right: 24px;padding-top: 80px">
        <van-form validate-first @failed="onFailed" :show-error="false">
          <!-- 通过 pattern 进行正则校验 -->
          <van-field
              v-model="phone"
              name="phone"
              placeholder="请输入手机号"
              :rules="[{ pattern, message: '请输入正确的手机号' }]"
              clearable


          />
          <van-field
              v-model="sms"
              name="sms"
              center
              placeholder="请输入短信验证码"
              :rules="[{ pattern:patternSMS, message: '请输入正确的验证码' }]"
              clearable
          >
            <template #button>
              <div class="getSMS" @click="getSMS">获取验证码</div>
            </template>
          </van-field>


          <div></div>


        </van-form>
      </div>
      <div style="padding-left: 40px;padding-right: 40px">
        <div class="agreementBox">
          <span class="agreementText">*若您的手机号第一次登录图表家，将为您自动注册,并表示您已经同意</span>
          <a class="agreement">
            <router-link to="/userAgreement" style="color: #1875f7;text-decoration: underline;">《图表家用户协议》</router-link>
          </a>
        </div>


        <div class="loginButton" @click="login">登录</div>

        <div class="passwordLogin">
          <router-link to="/loginPW" style="color: #585e6a">密码登录</router-link>
        </div>
        <div class="otherTitle">- 其他登录方式 -</div>
        <div class="other">
          <div class="qq circular" @click="$toast('第三方功能接入中，敬请期待');">
            <svg-icon icon-class="qq" style="height: 19px;width: 16px"/>
          </div>
          <div class="wechat circular" @click="$toast('第三方功能接入中，敬请期待');">
            <svg-icon icon-class="wechat" style="height: 19px;width: 21px"/>
          </div>
          <div class="sina circular" @click="$toast('第三方功能接入中，敬请期待');">
            <svg-icon icon-class="sina" style="height: 17px;width: 20px"/>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      phone: '',
      sms: '',
      pattern: /^[1][345789][0-9]{9}$/,
      patternSMS: /^[0-9]{4}$/,


    }
  },
  methods: {
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },

    getSMS() {
      let phoneCheck = this.phone.search(this.pattern)
      if (phoneCheck === 0) {
        let query = this.$encrypt(this.$genQuery({mobile: this.phone, type: 1}))
        this.$post(this.$store.state.apiUrl + '/sms/get_nosms', {qdata: query}).then(res => {
          if (res.status === 0) {
            this.$toast(res.msg);
          } else {
            this.$toast(res.msg);
          }

        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$toast('请输入正确的手机号');
      }


    },


    login() {
      let phoneCheck = this.phone.search(this.pattern)
      let smsCheck = this.sms.search(this.patternSMS)
      if (phoneCheck === 0 && smsCheck === 0) {
        let query = this.$encrypt(this.$genQuery({
          mobile: this.phone,
          sms_code: this.sms,
          country_source: 0,
          country_code: 86
        }))
        this.$post(this.$store.state.apiUrl + '/member/quick_login', {qdata: query}).then(res => {
          if (res.status === 0) {
            this.$toast(res.msg);
            this.$setUserData(res)
            this.$store.state.SignedIn = true
            this.$router.push('/userCenter')


          } else{
            this.$toast(res.msg);
          }
        }).catch(err => {
          console.log(err)
        })

      } else {
        if (phoneCheck !== 0) {
          this.$toast('请输入正确的手机号');
        } else if (smsCheck !== 0) {
          this.$toast('请输入正确的验证码');
        }


      }

    },
    back(){
      this.$router.push('/userCenter')
    }
  }

}
</script>

<style scoped>


.agreementBox {
  text-align: left;
  height: 60px;
  width: 100%;
  margin: 10px auto;
}

.agreementText {
  color: #919bad;
  font-size: 11px;

}

.agreement {
  font-size: 11px;


}



.passwordLogin {
  text-align: left;
  font-size: 13px;
  margin-top: 10px;
  margin-bottom: 60px;
}

.otherTitle {
  font-size: 12px;
  color: #919bad;
  text-align: center;

}

.other {
  display: flex;
  justify-content: space-around;
  padding-top: 30px;
}


.circular {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qq {
  border: 1px solid #12b7f5;
}

.wechat {
  border: 1px solid #36b02b;
}

.sina {
  border: 1px solid #f85a45;
}


</style>
